// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._UsG4AcK27cY6RbgKiIX{margin-left:20px;margin-right:20px}.BqknqIA4f2MXEfm1DE41{background:var(--border-neutral-default);width:calc(100% - 40px);height:1px;margin:16px 20px;display:flex}.Xj8TL92331gNJwNbll2T{justify-content:space-between;padding:8px 20px 12px;display:flex}.gvBmGbzO4fAvfKWAqtk6{align-items:center;gap:10px;display:flex}.gvBmGbzO4fAvfKWAqtk6 input{height:20px;font-size:16px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filterWrapper": `_UsG4AcK27cY6RbgKiIX`,
	"separator": `BqknqIA4f2MXEfm1DE41`,
	"searchWrap": `Xj8TL92331gNJwNbll2T`,
	"search": `gvBmGbzO4fAvfKWAqtk6`
};
export default ___CSS_LOADER_EXPORT___;
